import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../services/api";
import ToastContext from "../contexts/ToastContext";
import AuthContext from "../contexts/AuthContext";
import PageHeader from "../components/PageHeader";
import { FaDownload } from "react-icons/fa";
import "./RecursoPages.css";

function DetalheRecursoControlador() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { addToast } = useContext(ToastContext);
  const { user } = useContext(AuthContext);

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [recurso, setRecurso] = useState(null);

  const [status, setStatus] = useState("Pendente");
  const [resposta, setResposta] = useState("");
  const [medidas, setMedidas] = useState("");

  const uploadsBaseUrl = (process.env.REACT_APP_API_URL || "http://localhost:3001/api").replace(
    /\/api\/?$/,
    ""
  );

  const basePath = Number(user?.perfil_id) === 1 ? "/admin/recursos" : "/controlador/recursos";

  useEffect(() => {
    let mounted = true;
    async function fetchRecurso() {
      setLoading(true);
      try {
        const { data } = await api.get(`/recursos/${id}`);
        if (!mounted) return;
        setRecurso(data);
        setStatus(data.status || "Pendente");
        setResposta(data.resposta || "");
        setMedidas(data.medidas || "");
      } catch (error) {
        addToast("Erro ao buscar recurso.", "error");
      } finally {
        if (mounted) setLoading(false);
      }
    }

    fetchRecurso();
    return () => {
      mounted = false;
    };
  }, [addToast, id]);


  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.patch(`/recursos/controlador/${id}/decisao`, {
        status,
        resposta,
        medidas,
      });
      addToast("Decisão salva.", "success");
      navigate(basePath);
    } catch (error) {
      addToast(
        error?.response?.data?.message || "Erro ao salvar decisão.",
        "error"
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <PageHeader title="Recurso - Análise" />
      {loading ? (
        <p>Carregando...</p>
      ) : !recurso ? (
        <p>Recurso não encontrado.</p>
      ) : (
        <div className="recurso-page">
          <div className="surface-section">
            <h2 className="recurso-section-title">
              <span>
                {recurso.edital_titulo} - Edital Nº {recurso.numero_edital}/{recurso.ano_edital}
              </span>
              <span className="pill">{recurso.status}</span>
            </h2>

            <div className="recurso-meta" style={{ marginTop: 12 }}>
              <div>
                <strong>Candidato:</strong> {recurso.nome_completo} (CPF: {recurso.cpf})
              </div>
              <div>
                <strong>Inscrição:</strong> {String(recurso.inscricao_id).padStart(4, "0")}
              </div>
              <div>
                <strong>Cargo:</strong> {recurso.nome_cargo}
              </div>
              <div>
                <strong>ID do recurso:</strong> {recurso.id}
              </div>
              {recurso.criado_em ? (
                <div>
                  <strong>Criado em:</strong> {new Date(recurso.criado_em).toLocaleString()}
                </div>
              ) : null}
              {recurso.atualizado_em ? (
                <div>
                  <strong>Atualizado em:</strong> {new Date(recurso.atualizado_em).toLocaleString()}
                </div>
              ) : null}
              <div>
                <strong>Anexos:</strong> {Array.isArray(recurso.anexos) ? recurso.anexos.length : 0}
              </div>
            </div>

            <hr style={{ margin: "18px 0" }} />

            <p><strong>Decisão contestada</strong></p>
            <div className="recurso-pre">{recurso.decisao_contestada}</div>
            <p style={{ marginTop: 14 }}><strong>Argumentos</strong></p>
            <div className="recurso-pre">{recurso.argumentos}</div>

          {recurso.anexos_descricao ? (
            <>
              <p style={{ marginTop: 14 }}><strong>Descrição dos anexos</strong></p>
              <div className="recurso-pre">{recurso.anexos_descricao}</div>
            </>
          ) : null}

          <hr style={{ margin: "18px 0" }} />

          <div className="recurso-anexos">
            <p style={{ margin: 0 }}><strong>Anexos</strong></p>
            {Array.isArray(recurso.anexos) && recurso.anexos.length ? (
              <ul className="recurso-anexos__list">
                {recurso.anexos.map((a) => (
                  <li key={a.id} className="recurso-anexos__item">
                      <div className="recurso-anexos__info">
                        <span className="recurso-anexos__name">{a.nome_arquivo}</span>
                        {a.hash_sha256 ? (
                          <span className="recurso-anexos__hash" title={a.hash_sha256}>
                            SHA-256: {String(a.hash_sha256).slice(0, 12)}…
                          </span>
                        ) : null}
                      </div>
                    <div className="recurso-anexos__actions">
                      <a
                        className="btn-modern btn-ghost"
                        href={`${uploadsBaseUrl}/uploads/${a.caminho_arquivo}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <FaDownload />
                        <span>Baixar</span>
                      </a>
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="muted-text">Nenhum anexo enviado.</p>
            )}
          </div>

          </div>

          <div className="surface-section">
            <div className="decision-header">
              <h3 style={{ margin: 0 }}>Decisão do Controlador</h3>
              <p className="decision-help">
                Dica: use <strong>Em Análise</strong> enquanto estiver avaliando. Marque <strong>Deferido</strong> ou <strong>Indeferido</strong> quando finalizar.
              </p>
            </div>

            <form className="modern-form" onSubmit={handleSave}>
              <div className="decision-grid">
                <label>
                  Status do recurso
                  <select value={status} onChange={(e) => setStatus(e.target.value)}>
                    <option value="Pendente">Pendente</option>
                    <option value="Em Análise">Em Análise</option>
                    <option value="Deferido">Deferido</option>
                    <option value="Indeferido">Indeferido</option>
                  </select>
                </label>

                <div className="decision-current">
                  <span className="muted-text">Status atual</span>
                  <div>
                    <span className="pill">{recurso.status}</span>
                  </div>
                </div>
              </div>

              <label>
                Resposta ao candidato (opcional)
                <textarea
                  value={resposta}
                  onChange={(e) => setResposta(e.target.value)}
                  rows={5}
                  placeholder="Explique a análise e a conclusão (ex.: conferência de documento, critérios do edital, revisão de pontuação, etc.)."
                />
              </label>

              <label>
                Medidas / Providências (opcional)
                <textarea
                  value={medidas}
                  onChange={(e) => setMedidas(e.target.value)}
                  rows={4}
                  placeholder="Se houver: ajuste de pontuação, solicitação de documento, encaminhamento para comissão, etc."
                />
              </label>

              <div className="decision-actions">
                <button
                  type="button"
                  className="button-secondary"
                  onClick={() => navigate(basePath)}
                  disabled={saving}
                >
                  Voltar
                </button>
                <button type="submit" disabled={saving}>
                  {saving ? "Salvando..." : "Salvar decisão"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default DetalheRecursoControlador;
